// extracted by mini-css-extract-plugin
module.exports = {"statusIcon":"styles__statusIcon___24ahG","badge":"styles__badge___3voJu","inner":"styles__inner___1qT_p"};